var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-10 ma-5"},[_c('v-card',{staticClass:"pa-5"},[_c('div',[_c('PageTitle',{staticClass:"pb-5",attrs:{"title":'GRN Details'}}),_c('GrnDetails')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }